import {
  GET_ALL_PRODUCT,
  DECREASE_QUANTITY,
  INCREASE_QUANTITY,
  DELETE_CART,
  START_LOADING,
  STOP_LOADING,
  ERROR,
} from "../actions";
const storedProducts = localStorage.getItem("products");

const initialState = {
  products: storedProducts ? JSON.parse(storedProducts) : [],
  loading: false,
  error: false,
};

const ProductCart = (state = initialState, action) => {
  switch (action.type) {
    // loading
    case START_LOADING:
      return {
        ...state,
        loading: true,
      };
    // stop loading
    case STOP_LOADING:
      return {
        ...state,
        loading: false,
      };
    // get all products
    case GET_ALL_PRODUCT:
      const newState = { ...state, products: action.payload };
      localStorage.setItem("products", JSON.stringify(newState.products));
      return newState;
    // increase quantity
    case INCREASE_QUANTITY:
      const updatedProductWithIncrement = state.products.map((product) =>
        product.productDetail.productId === action.payload.productId
          ? { ...product, quantity: product.quantity }
          : product,
      );
      const stateAfterUpdatedProductWithIncrement = {
        ...state,
        products: updatedProductWithIncrement,
      };
      localStorage.setItem(
        "products",
        JSON.stringify(stateAfterUpdatedProductWithIncrement.products),
      );
      return stateAfterUpdatedProductWithIncrement;
    // decrease quantity
    case DECREASE_QUANTITY:
      const updatedProductWithDecrement = state.products.map((product) =>
        product.productDetail.productId === action.payload.productId
          ? { ...product, quantity: product.quantity }
          : product,
      );
      const stateAfterUpdatedProductWithDecrement = {
        ...state,
        products: updatedProductWithDecrement,
      };
      localStorage.setItem(
        "products",
        JSON.stringify(stateAfterUpdatedProductWithDecrement.products),
      );
      return stateAfterUpdatedProductWithDecrement;
    // cart delete
    case DELETE_CART:
      const filteredProductList = state.products.filter(
        (product) =>
          product.productDetail.productId !== action.payload.productId,
      );
      const stateAfterDelete = { ...state, products: filteredProductList };
      localStorage.setItem(
        "products",
        JSON.stringify(stateAfterDelete.products),
      );
      return stateAfterDelete;
    case ERROR:
      return {
        ...state,
        error: true,
      };

    default:
      return state;
  }
};

export { ProductCart };
